module.exports = __webpack_public_path__ + "src/assets/img/logo_topclass_color.da80b085.svg";